import * as React from 'react';
import HorizontalItem, { getItemSize, HorizontalItemSize } from './items/HorizontalItem';
export default function DescriptiveShowcase(props) {
    var _a, _b, _c, _d;
    const { header, items, seeMoreItem, onEndOfWidget } = props.data;
    if ((_a = items) === null || _a === void 0 ? void 0 : _a.length) {
        const sizes = items.map(item => getItemSize(item));
        const maxSize = sizes.reduce((acc, size) => size > acc ? size : acc, HorizontalItemSize.Small);
        return (React.createElement("div", null,
            React.createElement("music-shoveler", { key: header, "see-all": (_b = seeMoreItem) === null || _b === void 0 ? void 0 : _b.text, "primary-text": header, wrap: "1", onmusicSeeAllActivate: props.handleSelected.bind(null, (_d = (_c = seeMoreItem) === null || _c === void 0 ? void 0 : _c.primaryLink) === null || _d === void 0 ? void 0 : _d.onItemSelected), onmusicScrolledToEndActivate: props.handleSelected.bind(null, onEndOfWidget) }, items.map((item, i) => (React.createElement(HorizontalItem, { data: item, handleSelected: props.handleSelected, size: sizes[i], parentSize: maxSize }))))));
    }
    return null;
}
;
